import type { CSSProperties } from "react";

import styles from "../style.module.scss";

interface IStepTitle {
    title: string;
    subtitle: string;
    style?: CSSProperties;
}

/**
 * Title for each step of the import modal (they have same design, avoids CSS copies).
 */
const StepTitle = ({ title, subtitle, style }: IStepTitle) => {
    return (
        <div className={styles["title-step"]} style={style}>
            <h2>{title}</h2>
            <span>{subtitle}</span>
        </div>
    );
};

export default StepTitle;
